import React from 'react'
import Script from 'react-load-script'
let OneSignal
class Onesingnal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      items: []
    }
  }
  handleScriptLoad = () => {
    const { user, createPlayer } = this.props

    OneSignal = window.OneSignal
    OneSignal.push(function () {
      OneSignal.init({
        appId: "50f1b0d0-96fa-4be1-b244-1f8f68ba39fc",
      })
      OneSignal.getUserId(function (userId) {
        // console.log('player_id of the subscribed user is : ' + user, userId)
        createPlayer({ user_code: user, player_id: userId })
      })
    })
  }

  render() {
    return (
      <Script url="https://cdn.onesignal.com/sdks/OneSignalSDK.js" onLoad={this.handleScriptLoad.bind(this)} />
    )
  }
}

export default Onesingnal 